import axios from '../config/axios.js'
const BASE_URL = '/api/college_manage'
export const studentCenterServer = {
  queryPlatformStudentList: (params) => {
    return axios.get(`${BASE_URL}/student/queryPlatformStudentList`, {params: params}).then(res => res.data)
  },
  studentAnalysisChapterList: (params) => {
    return axios.get(`${BASE_URL}/student/studentAnalysisChapterList`, {params: params}).then(res => res.data)
  },
  studentAnalysisDetail: (params) => {
    return axios.get(`${BASE_URL}/student/studentAnalysisDetail`, {params: params}).then(res => res.data)
  }
}


// WEBPACK FOOTER //
// ./src/api/server/studentCenter.js